var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 77337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 77336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 359",
    d: "M16.4173 3.60254L4.42782 7.68986L3.61035 10.1423L6.33524 21.3143L9.6051 24.0392C13.6016 22.7676 21.6491 20.2243 21.8671 20.2243C22.0851 20.2243 23.0479 18.4077 23.502 17.4994L22.6845 12.8671L19.6872 4.96498L16.4173 3.60254Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4505 21.988L12.4045 24.4493C9.27543 25.4064 6.00363 23.614 5.066 20.5488L2.60473 12.5027C1.64756 9.37368 3.44004 6.10188 6.50522 5.16426L14.5513 2.70298C17.6803 1.74582 20.9521 3.5383 21.8897 6.60347L24.351 14.6496C25.2886 17.7147 23.5157 21.0504 20.4505 21.988ZM7.16937 7.33541C5.31749 7.9019 4.25373 9.90329 4.82021 11.7552L7.28149 19.8012C7.84797 21.6531 9.84936 22.7169 11.7012 22.1504L19.7473 19.6891C21.5992 19.1226 22.6629 17.1213 22.0965 15.2694L19.6547 7.28716C19.0882 5.43529 17.0868 4.37152 15.235 4.93801L7.1889 7.39928L7.16937 7.33541Z",
    fill: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.0075 15.4092L10.5319 13.6485C10.1008 13.3252 9.55056 13.4572 9.25857 13.8383C8.92733 14.2707 9.05854 14.8261 9.44214 15.1199L9.44836 15.1247L9.45473 15.1293L12.7939 17.525C13.0325 17.6983 13.3173 17.7459 13.5996 17.6596C13.7942 17.6001 14.0605 17.4733 14.1896 17.1514L18.0959 9.13576L18.102 9.12326L18.1074 9.11045C18.2872 8.68262 18.1299 8.16372 17.6844 7.92698L17.6644 7.91633L17.6435 7.90754C17.2157 7.72773 16.6968 7.88506 16.46 8.33049L16.456 8.33817L16.4521 8.34599L13.0075 15.4092Z",
    fill: "#536D9A",
    stroke: "#536D9A"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickStep);
export default __webpack_public_path__ + "static/media/TickStep.13dc2cf890725e637bcff45ebbb56b3b.svg";
export { ForwardRef as ReactComponent };